import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressbarService {
  constructor() { }
  public usersWaitBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public rolesWaitBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  public showUsersWaitBar(show: boolean) {
    this.usersWaitBar.next(show);
  }

  public showRolesWaitBar(show: boolean) {
    this.rolesWaitBar.next(show);
  }
}
